import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Button from '@react/react-spectrum/Button'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'

export default function CreateNewCredentialsButton (props) {
    const { referrer } = props
    const { ut, userOrgs, dispatch } = useContext(EasybakeContext)

    function go (e, referrer) {
        analytics.sendEventName('click', `${referrer}:createnewcredentials`)
        dispatch({ type: 'set-page', payload: { page: 'create' } })
    }
    return (
        <Button 
            {...props}
            label={__('console_get_started_btn_create')}
            disabled={!ut || userOrgs && userOrgs.length === 0}
            variant="cta" 
            onClick={(e) => go(e, referrer)}
        />
    )
}
